/** This is the *old* blinq icon path. This should not be used. It only remains here for very legacy usages that are
 * hard to remove.
 * @deprecated
 */
export const BlinqIconPath: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <path
      fill="currentColor"
      d="M85.333 432.356c47.129 0 85.334-38.204 85.334-85.334H153.6c0 37.703-30.564 68.267-68.267 68.267-37.702 0-68.266-30.564-68.266-68.267v51.209c15.568 20.722 40.352 34.125 68.266 34.125zm0-170.667c47.129 0 85.334 38.204 85.334 85.333H153.6c0-37.703-30.564-68.266-68.267-68.266-37.702 0-68.266 30.563-68.266 68.266v-51.208c15.568-20.722 40.352-34.125 68.266-34.125zm0-17.067c47.129 0 85.334-38.205 85.334-85.333H153.6c0 37.702-30.564 68.267-68.267 68.267-37.702 0-68.266-30.565-68.266-68.267v51.208c15.568 20.722 40.352 34.125 68.266 34.125zm0-170.666c47.129 0 85.334 38.205 85.334 85.333H153.6c0-37.703-30.564-68.267-68.267-68.267-37.702 0-68.266 30.564-68.266 68.267V108.08c15.568-20.722 40.352-34.125 68.266-34.125zM0 0h17.067v512H0V0z"
    ></path>
  );
};
